<script setup lang="ts">
defineProps({
  imgSrc: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  subTitle: {
    type: String,
    required: true
  },
  selected: {
    type: Boolean
  }
});

const emits = defineEmits(['templateClick']);

const onClick = () => {
  emits('templateClick');
};
</script>

<template>
    <div class="template-root"
        :class="{ selected }"
        v-ripple
        @click="onClick">
        <img :src="imgSrc" v-ripple/>
        <h3 class="title">{{ title }}</h3>
        <p class="subtitle">{{ subTitle }}</p>
    </div>
</template>

<style lang="scss" scoped>
@use '../../../assets/variables.module' as *;
.template-root {
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    max-width: 250px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    cursor: pointer;

    img {
        max-height: 200px;
    }

    .title {
        margin-top: 24px;
        font-size: 16px;
        font-weight: 700;
        text-align: start;
    }

    .subtitle {
        text-align: start;
        line-height: 20px;
        margin-top: 8px;
        color: #575e66;
    }

    // Selected used to be a JS-computed literal; the class keeps the colour in SCSS.
    &.selected,
    &:hover {
        border-color: $primary-color;
    }
}
</style>
